import {
  FETCH_USER_APP_VERSION,
  FETCH_USER_WIDGETS,
  FETCH_AVAILABLE_WIDGETS,
  FETCH_BEST_CLIENTS_WIDGETS,
  FETCH_WAITING_PROCESSED_WIDGETS,
  FETCH_WAITING_DELIVERED_WIDGETS,
  FETCH_ORDER_RECEIVED_WIDGETS,
  FETCH_REVENUE_WIDGETS,
  FETCH_POPULAR_PRODUCTS_WIDGETS,
  FETCH_SOLD_PRODUCTS_WIDGETS,
  GET_ACCOUNT,
  GET_ADDRESS,
  GET_CONTACT,
  GET_ORGANIZATION_SETTINGS,
  RESET_PROFILE,
  GET_PUBLIC_PROFILE,
  FETCH_BUSINESS_HOURS,
  DESTROY_BUSINESS_HOUR,
  FETCH_BUSINESS_HOUR_EXCEPTIONS,
  DESTROY_BUSINESS_HOUR_EXCEPTION,
  STORE_BUSINESS_HOUR,
  STORE_BUSINESS_HOUR_EXCEPTION,
  FETCH_USER_APP_TOAST,
} from './../../mutation-types';

export default {
  [FETCH_USER_APP_VERSION](state, appVersionData) {
    state.userAppVersion = appVersionData;
  },

  [FETCH_USER_WIDGETS](state, widgetsData) {
    state.userWidgets = widgetsData;
  },

  [FETCH_AVAILABLE_WIDGETS](state, availableWidgetsData) {
    state.availableWidgets = availableWidgetsData;
  },

  [FETCH_BEST_CLIENTS_WIDGETS](state, bestClientsWidgetsData) {
    state.bestClientsWidgets = bestClientsWidgetsData;
  },

  [FETCH_WAITING_PROCESSED_WIDGETS](state, waitingProcessedWidgetsData) {
    state.waitingProcessedWidgets = waitingProcessedWidgetsData;
  },

  [FETCH_WAITING_DELIVERED_WIDGETS](state, waitingDeliveredWidgetsData) {
    state.waitingDeliveredWidgets = waitingDeliveredWidgetsData;
  },

  [FETCH_ORDER_RECEIVED_WIDGETS](state, orderReceivedWidgetsData) {
    state.orderReceivedWidgets = orderReceivedWidgetsData;
  },

  [FETCH_REVENUE_WIDGETS](state, revenueWidgetsData) {
    state.revenueWidgets = revenueWidgetsData;
  },

  [FETCH_POPULAR_PRODUCTS_WIDGETS](state, popularProductsWidgetsData) {
    state.popularProductsWidgets = popularProductsWidgetsData;
  },

  [FETCH_SOLD_PRODUCTS_WIDGETS](state, soldProductsWidgetsData) {
    state.soldProductsWidgets = soldProductsWidgetsData;
  },

  [GET_ACCOUNT](state, account) {
    state.account = account;
  },

  [GET_ADDRESS](state, address) {
    state.address = address;
  },

  [GET_CONTACT](state, contact) {
    state.contact = contact;
  },

  [GET_ORGANIZATION_SETTINGS](state, settings) {
    state.settings = settings;
  },

  [GET_PUBLIC_PROFILE](state, publicProfile) {
    state.publicProfile = publicProfile;
  },

  [FETCH_BUSINESS_HOURS](state, hours) {
    state.businessHours = hours;
  },

  [STORE_BUSINESS_HOUR](state, hour) {
    state.businessHours.push(hour);
  },

  [DESTROY_BUSINESS_HOUR](state, id) {
    state.businessHours = state.businessHours.filter(h => (
      h.id.toString() !== id.toString()
    ));
  },

  [FETCH_BUSINESS_HOUR_EXCEPTIONS](state, hours) {
    state.businessHourExceptions = hours;
  },

  [STORE_BUSINESS_HOUR_EXCEPTION](state, hour) {
    state.businessHourExceptions.push(hour);
  },

  [DESTROY_BUSINESS_HOUR_EXCEPTION](state, id) {
    state.businessHourExceptions = state.businessHourExceptions.filter(e => (
      e.id.toString() !== id.toString()
    ));
  },

  [RESET_PROFILE](state) {
    state.account = {};
    state.address = {};
    state.contact = {};
    state.settings = {};
    state.publicProfile = {};
    state.businessHours = [];
    state.businessHourExceptions = [];
  },

  [FETCH_USER_APP_TOAST](state, appToastData) {
    state.userAppToast = appToastData;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/profile/mutations.js